/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Shell_BackInputs */

const en_auth_shell_back = /** @type {(inputs: Auth_Shell_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to the site`)
};

const pl_auth_shell_back = /** @type {(inputs: Auth_Shell_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wróć na stronę`)
};

/**
* | output |
* | --- |
* | "Back to the site" |
*
* @param {Auth_Shell_BackInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_shell_back = /** @type {((inputs?: Auth_Shell_BackInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Shell_BackInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_shell_back(inputs)
	return en_auth_shell_back(inputs)
});